import React from 'react';
import { ReactTransliterate } from 'react-transliterate';
import 'react-transliterate/dist/index.css';

export const TeluguInput = ({ value, onChange, placeholder, className, enabled = true }) => {
  if (!enabled) {
    return (
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={className}
      />
    );
  }

  return (
    <ReactTransliterate
      value={value}
      onChangeText={(text) => onChange(text)}
      lang="te"
      placeholder={placeholder}
      className={className}
      containerClassName="w-full"
    />
  );
};
